'use strict';

import objectFitImages from 'object-fit-images';
import 'slick-carousel';

export default class DetailCarousel {
  constructor() {

    objectFitImages('img.detail-carousel__item-image');

    const responsiveSetting = () => {
        const numberOfSliders = $('.detail-carousel').children().length;

        if (numberOfSliders == 1) {
            return [];
        } else if (numberOfSliders == 2) {
            $('.detail-carousel').addClass('full-height');
            return [
                {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        } else if (numberOfSliders > 2) {
            return [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    }

    const detailCarouselSettings = {
        autoplay: false,
        mobileFirst: true,
        arrows: true,
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: responsiveSetting()
    };

    if ($('.detail-carousel').length) {
        $('.detail-carousel').slick(detailCarouselSettings)
    }

  }
}
